import type { IMessageShape } from './message';
import type { IStaff, IOrganisation, ICompany } from '../organisations';
import type { IUser } from '../users';
import type { IConversation } from './conversation';
import type { IRecordingHeader } from '../recordings';
import type { ISnapshot } from '../vision';
import type { IEvent } from '../events';
import type { IReview } from '../conversation-reviews';
import type { IInvitation } from '../invitations';
import { Joi, objectSchemaOf } from '../helpers';

export const conversationLoadPageParamsSchema = objectSchemaOf<IConversationLoadPageParams>(
  {
    conversationId: Joi.string().required(),
  }
);

export interface IConversationLoadPageParams {
  conversationId: string;
}

export interface IConversationLoadPageResult {
  messages: IMessageShape[];
  recordings: IRecordingHeader[];
  snapshots: ISnapshot[];
  conversation: IConversation;
  consoleUser: IUser;
  organisation: IOrganisation;
  companies: ICompany[];
  staff: IStaff[];
  events: IEvent[];
  review?: IReview;
  upcomingInvitations: IInvitation[];
}
